import Container from "react-bootstrap/esm/Container";
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import heroImage from "../images/hero-image.png"

export default function Home() {
  return (
    <>
      <div className="hero-container">
        <h1>Element<br/>Data</h1>
        <img src={heroImage} alt="world-map"/>
      </div>
      <Container>
        <h2 id="config_header">About</h2>
        <div className="bottom-line"></div>
        <p className="config_lead">
          The aim of this project is to monitor and collect indoor air quality data. The compatible device with our network is the Awair Element .
          Vastly different approaches than standard, will be used to achieve our goals. Most of the existing projects are For-Profit only,
          making the biggest profit for the investors , owners and CEOs. The shareholders and investors are promised a bigger profit every year ,
          making it very difficult to trickle down the same profits to device owners and workers in general. Our model will be very similar
          in nature to a non-profit organization. Transparency will be our main driving value, making it trustworthy for the device owners
          that join the ElementData project . The ElementData team will be naturally compensated for their work, and the rest of the profits
          distributed to device owners and proportionally invested back into the project, making it possible to grow .
          The device owners will be rewarded for their data with cryptocurrency. To join and participate in the project , you will need
          to download a very small application that will run in the background of your computer communicating with the air monitoring
          device , making it possible to send the data back to us. We really believe in
          our idea to build the largest indoor air quality database, and at the same time share the profits as deserved with everyone.
          If you already own the device, consider joining us to fight the good fight and make a difference.
        </p>
        <br/>
        <h3 id="config_header">The device</h3>
        <div className="bottom-line"></div>
        <p className="config_lead">
          In order to join and become a part of our network, you need the Awair Element air monitor
        </p>
        <br/>
        <br/>
        <CardGroup>
          <Card className="text-center" bg="dark" style={{width: '18rem'}}>
            <Card.Body>
              <Card.Title><i className="bi bi-wallet2 h3"></i></Card.Title>
              <Card.Text id="card-header">affordable</Card.Text>
              <Card.Text id="card-text">If you don't already own it, you should. It's a great air monitor device and it will improve the quality of your life</Card.Text>
            </Card.Body>
          </Card>
          <Card className="text-center" bg="dark" style={{width: '18rem'}}>
            <Card.Body>
              <Card.Title><i className="bi bi-pc-display-horizontal h3"></i></Card.Title>
              <Card.Text id="card-header">support</Card.Text>
              <Card.Text id="card-text">Awair's mobile app is easy to use and configure, now you can use the desktop app as well</Card.Text>
            </Card.Body>
          </Card>
          <Card className="text-center" bg="dark" style={{width: '18rem'}}>
            <Card.Body>
              <Card.Title><i className="bi bi-eye-fill h3"></i></Card.Title>
              <Card.Text id="card-header">visual</Card.Text>
              <Card.Text id="card-text">It looks great, and it can be also used as an elegant digital clock</Card.Text>
            </Card.Body>
          </Card>
          <Card className="text-center" bg="dark" style={{width: '18rem'}}>
            <Card.Body>
              <Card.Title><i className="bi bi-hand-thumbs-up-fill h3"></i></Card.Title>
              <Card.Text id="card-header">win-win</Card.Text>
              <Card.Text id="card-text">You already own the device ? Connect it to our network and start earning rewards</Card.Text>
            </Card.Body>
          </Card>
        </CardGroup>
        <br/>
        <br/>
        <br/>
      </Container>
    </>
  )
}
